import { AfterViewInit, Component, HostListener, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-photo-viewer',
  templateUrl: './photoviewer.component.html',
  styleUrls: ['./photoviewer.component.css']
})
export class PhotoviewerComponent implements OnInit, AfterViewInit {
  @Input() dataImage: string[];

  zoomLevel: number = 1; // Initial zoom level
  translateX: number = 0; // X translation for dragging
  translateY: number = 0; // Y translation for dragging
  dragging: boolean = false; // State to track dragging
  dragStartX: number = 0;
  dragStartY: number = 0;
  rotation: number = 0; // Rotation angle in degrees
  currentImage: string[]; // Array of images passed to the dialog

  constructor(public activeModal: NgbActiveModal) { } // Inject NgbActiveModal

  ngOnInit() {
    this.currentImage = this.dataImage;
  }

  ngAfterViewInit() {
    // Force the modal to be full screen by adding a class or applying styles
    document.querySelector('.modal-content')?.classList.add('fullscreen-modal');
  }

  closeDialog() {
    // this.dialogRef.close();
    this.activeModal.close(); // Close the modal
  }

  // Zoom In
  zoomIn() {
    this.zoomLevel += 0.1;
  }

  // Zoom Out
  zoomOut() {
    if (this.zoomLevel > 0.2) {
      this.zoomLevel -= 0.1;
    }
  }

  // Reset Zoom and Position
  resetZoom() {
    this.zoomLevel = 1;
    this.translateX = 0;
    this.translateY = 0;
    this.rotation = 0; // Reset rotation to 0
  }

  // Rotate Clockwise
  rotateClockwise() {
    this.rotation += 90;
  }

  // Rotate Counterclockwise
  rotateCounterClockwise() {
    this.rotation -= 90;
  }

  // Handle Mouse Wheel for Zoom
  onWheel(event: WheelEvent) {
    event.preventDefault();
    if (event.deltaY > 0) {
      this.zoomOut();
    } else {
      this.zoomIn();
    }
  }

  startDrag(event: MouseEvent) {
    if (event.target instanceof HTMLImageElement) {
      event.preventDefault(); // Prevent default action
      this.dragging = true;
      this.dragStartX = event.clientX - this.translateX;
      this.dragStartY = event.clientY - this.translateY;
    }
  }

  onDrag(event: MouseEvent) {
    if (this.dragging) {
      requestAnimationFrame(() => {
        this.translateX = event.clientX - this.dragStartX;
        this.translateY = event.clientY - this.dragStartY;
      });
    }
  }

  endDrag() {
    this.dragging = false;
  }

  // Listen for keyboard events for zooming
  @HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    // Check if the + or - key was pressed
    if (event.key === '+') {
      this.zoomIn();
    } else if (event.key === '-') {
      this.zoomOut();
    } else if (event.key === 'Escape') { // Check for the Escape key
      this.closeDialog(); // Close the dialog
    }
  }
}
